import { useEnterTenant } from '@/hooks/useEnterTenant';
import { getTenantDisplayName } from '@/utils/tenant-display';
import { Button, Select, Selection, SelectItem } from '@nextui-org/react';
import React from 'react';
import { useAuthStore } from '../../../store/use-auth-store';

export const TenantSelector = () => {
  const enterTenant = useEnterTenant();
  const [selectedTenant, setSelectedTenant] = React.useState<Selection>(
    new Set([])
  );
  const { tenants } = useAuthStore();

  const handleTenantChange = (keys: Selection) => {
    setSelectedTenant(keys);
  };

  const handleProceed = () => {
    const selectedValue = Array.from(selectedTenant)[0] as string;
    if (selectedValue && tenants) {
      const selectedTenantObj = tenants.find(
        (t) => t.id.toString() === selectedValue
      );
      if (selectedTenantObj) {
        enterTenant(selectedTenantObj);
      }
    }
  };

  return (
    <div className="flex flex-col gap-4 w-full justify-center items-center">
      <div className="flex flex-col items-center pb-6">
        <p className="text-xl font-medium">Select your tenant</p>
        <p className="text-small text-default-500">
          Choose the Tenant you want to access
        </p>
      </div>

      <Select
        className="max-w-xs mb-4"
        variant="bordered"
        selectedKeys={selectedTenant}
        onSelectionChange={handleTenantChange}
        placeholder="Select Tenant"
        items={tenants || []}
      >
        {(tenant) => (
          <SelectItem key={tenant.id.toString()} value={tenant.id.toString()}>
            {getTenantDisplayName(tenant.name)}
          </SelectItem>
        )}
      </Select>

      <Button
        onClick={handleProceed}
        isDisabled={
          selectedTenant === 'all' ||
          (selectedTenant instanceof Set && selectedTenant.size === 0)
        }
        color="primary"
        className="max-w-xs"
      >
        Proceed
      </Button>
    </div>
  );
};

export default TenantSelector;
